import { tokensOf } from "@/model/tokens";
import type { Exporter } from "./types";

/** Base themes Claude Code accepts for a custom theme (Claude Code 2.1.314). */
export const CLAUDE_BASES = [
  "dark",
  "light",
  "dark-daltonized",
  "light-daltonized",
  "dark-ansi",
  "light-ansi",
] as const;

export const claudeCode: Exporter = {
  id: "claude-code",
  label: "Claude Code",
  app: true,
  description: "Custom theme JSON in ~/.claude/themes with all 72 color overrides.",
  run: (ctx) => {
    const { color, theme, appName } = ctx;
    const overrides = Object.fromEntries(tokensOf("claude").map((t) => [t.key, color(t.id)]));
    const json = { name: theme.name, base: theme.variant, overrides };
    return {
      files: [
        {
          path: `~/.claude/themes/${appName}.json`,
          filename: `${appName}.json`,
          language: "json",
          content: `${JSON.stringify(json, null, 2)}\n`,
        },
      ],
      steps: [
        `Create \`~/.claude/themes/${appName}.json\` with the file below (make the \`themes\` directory if needed).`,
        `Select it: run \`/theme\` in Claude Code and pick "${theme.name}", or set \`"theme": "custom:${appName}"\` in \`~/.claude/settings.json\` (keep the other settings).`,
      ],
      verify: [
        `jq -e '.base and (.overrides | length == ${Object.keys(overrides).length})' ~/.claude/themes/${appName}.json`,
      ],
      notes: [
        "Keys are Claude Code's theme tokens; any key Claude Code does not know is ignored, and a missing key falls back to the base theme.",
      ],
    };
  },
};
